import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { ITipoReglaModel } from 'src/app/models/interfaces/tipo-regla/ITipoReglaModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { TipoReglaModel } from 'src/app/models/tipo-regla/TipoReglaModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { TipoReglaService } from 'src/app/services/tipo-regla/tipo-regla.service';

@Component({
  selector: 'app-configuracion-tipo-regla-registrar',
  templateUrl: './configuracion-tipo-regla-registrar.component.html',
  styleUrls: ['./configuracion-tipo-regla-registrar.component.css']
})
export class ConfiguracionTipoReglaRegistrarComponent implements OnInit {
  model: ITipoReglaModel = new TipoReglaModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();

  constructor(
    private router: Router,
    private gbuService: TipoReglaService,
    private serviceParametros: ParametroService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
  ) { }

  ngOnInit(): void {
    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_MAESTRO).subscribe((data) => {
      this.listaEstados = data.items;
    });
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {   
      this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.gbuService.submit(this.model).subscribe((data) => {
            this.alertDialogService.open("El tipo de regla fue registrado");
            this.router.navigate(['/configuracion', 'tipo-reglas']);  
          });
        }
      });
    }
  }

}
